/* eslint-disable max-len */
/* ! CSS Used from: https://tailwindui.com/v2-assets/components.css?id=1be59baa12632495b28467ad50226d7a */

import { NullFunction } from '@deqo/foundation';
import React, { useCallback, useRef } from 'react';
import styled from 'styled-components';
import { Colors } from '.';
import { HelpTip } from './Tip';

const Input = styled.input`

    appearance: none;
    padding: 0;
    color-adjust: exact;
    display: inline-block;
    vertical-align: middle;
    background-origin: border-box;
    user-select: none;
    flex-shrink: 0;
    height: 1.2rem;
    width: 1.2rem;
    color: ${Colors.primary};
    background-color: #fff;
    border: solid 1px rgb(209 213 219 / 1);
    border-radius: .25rem;

    :-moz-focusring {
        outline: auto;
    }

    &::-moz-placeholder {
        opacity: 1;
        color: #9ca3af;
    }

    &:-ms-input-placeholder {
        opacity: 1;
        color: #9ca3af;
    }

    &::placeholder {
        opacity: 1;
        color: #9ca3af;
    }

    :disabled {
        cursor: default;
    }

    &::-moz-placeholder {
        color: #6b7280;
        opacity: 1;
    }

    &:-ms-input-placeholder {
        color: #6b7280;
        opacity: 1;
    }

    &::placeholder {
        color: #6b7280;
        opacity: 1;
    }

    &:focus {
        outline: 2px solid transparent;
        outline-offset: 2px;
        box-shadow: 0 0 0 2px #fff, 0 0 0 4px ${Colors.primary};
    }

    &:checked {
        border-color: transparent;
        background-color: currentColor;
        background-size: 100% 100%;
        background-position: center;
        background-repeat: no-repeat;
    }

    &:checked {
        background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e");
    }

    &:checked:focus,
    &:checked:hover {
        border-color: transparent;
        background-color: currentColor;
    }
`;

const Frame = styled.div`
    display: flex;
    align-items: center;
    gap: .5rem;
`;

const Label = styled.label`
    user-select: none;
    color: ${Colors.text};
`;

export interface CheckboxProps {
    id?: string;
    name?: string;
    label?: string;
    helpText?: string;
    checked?: boolean;
    onChange?: (checked: boolean) => void;
}

const Base = React.memo<CheckboxProps>(({ id, name, label, helpText, checked, onChange }) => {
    checked = checked || false;
    onChange = onChange || NullFunction;

    const elmt = useRef<HTMLInputElement>();

    const onClick = useCallback((e: any) => {
        if (!elmt.current) return;
        if (e.target === elmt.current) return;
        elmt.current.click();
    }, [elmt.current]);

    return <Frame>
        <Input onClick={onClick} type="checkbox" ref={elmt} {...{ id, name, checked }} onChange={e => onChange(e.target.checked)} />
        {label && <Label onClick={onClick}>{label}</Label>}
        {helpText && <HelpTip content={helpText} />}
    </Frame>;
});

export const Checkbox = Object.assign(Base, { Frame, Input, Label });
